<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Route View</ion-title>
        @if (route.shuttle.status === 'Assigned') {
  <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons>
}
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-list-header color="secondary" data-test="header">
            Route For: {{route.shuttle.shuttleName}}<br />
            Shuttle Status: {{route.shuttle.status}}
        </ion-list-header>
    </ion-list>

    <!-- <pre>{{ route | json }}</pre> -->

    <ion-list class="ion-text-wrap ion-no-padding">
        @for (leg of route.routeLegs; track $index) {
  <ion-item class="ion-no-padding" data-test="routeLegs">
            <label class="ion-text-wrap" [class.urgent]="leg.isUrgent">
                <ion-grid>
                    <ion-row class="ion-align-items-center">
                        <ion-col class="letterCol ion-float-center" size="2" data-test="waypointNumber">
                            <!-- ion-float-left -->
                            <span class="letter">{{leg.waypointNumber}}</span>
                        </ion-col>

                        <ion-col class="legDescCol ion-float-right" size="10" data-test="leg">
                            <span class="line1" data-test="passenger">Passenger: {{leg.passengerName}}</span><br />
                            <span class="line1" data-test="from">From: {{leg.from.location.locationName}}</span><br />
                            @if (leg.from.location.address.fullAddress !== this.dealership.address.fullAddress) {
  <div>
                                <span class="line2">{{leg.from.location.address.fullAddress}}</span><br />
                            </div>
}

                            <span class="line1" data-test="to">To: {{leg.to.location.locationName}}</span><br />
                            @if (leg.to.location.address.fullAddress !== this.dealership.address.fullAddress) {
  <div>
                                <span class="line2">{{leg.to.location.address.fullAddress}}</span><br />
                            </div>
}
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </label>
        </ion-item>
}
    </ion-list>
</ion-content>